<div
  class="cash app-text-light px-1 app-text-bold my-1 py-1 d-flex justify-content-between primary-section-header-block align-items-center">
  <app-deal-type-selector (submitDealType)="submitDealType.emit($event)"></app-deal-type-selector>
</div>

<div class="px-1 my-1 pb-1 pt-2 d-flex justify-content-between">
  <span style="font-weight:bold;cursor: default">Total Amount Due</span>
  <div style="display: flex;flex-grow: 0;align-items: center;gap: 2px;justify-content: flex-end"
       (click)="updateMonthlyPriceOverride()" matTooltipPosition="above"
       matTooltip="Click to Override Total Amount Due">
    <div *ngIf="deal.financeOptionsEdits.amountFinanced !== null" style="cursor: pointer;position: relative">
      <mat-icon [style.color]="'#007bff'" style="position: absolute;top:-10px;left:-20px;">bolt</mat-icon>
    </div>
    <ng-container>
        <span class="app-text-blue hover-link-dotted">
        {{ deal.financeOptionsEdits.amountFinanced !== null ? (deal.financeOptionsEdits.amountFinanced | currency) : (totalVehicleCashPrice$ | async | currency) }}
        </span>
    </ng-container>
  </div>
</div>

<app-lender-select
  [lender]="lender"
  [lenderName]="lender?.name"
  [flagChange]="flagChange">
</app-lender-select>

<!--<app-smw-rebates-form
  [dealIncentives]="dealIncentives"
  [vehicleIncentives]="vehicleIncentives"
  dealType="cash"
  (updateIncentives)="onUpdateIncentives($event)">
</app-smw-rebates-form>-->

<div class="section-header">Products</div>

<app-smw-insurance-products-form
  [dealDefaults]="dealDefaults"
  (flagUnsavedChanges)="flagChange()"
  type="cash">
</app-smw-insurance-products-form>

<!-- <app-simple-input [fieldValue]="totalInsuranceProductsPrice$ | async | currency"
                  [name]="'Total Protection Adds'"
                  [type]="'number'">
</app-simple-input> -->

<!--<app-simple-input
  [fieldValue]="tradeInNetValue$ | async"
  name="Trade Net"
  type="number"
  pipe="currency">
</app-simple-input>-->

<!--<app-simple-input
  [fieldValue]="
  deal.financeOptionsEdits.amountFinanced !== null
  ? (deal.financeOptionsEdits.amountFinanced)
  : (totalVehicleCashPrice$ | async)"
  name="Total Amount Due"
  type="number"
  pipe="currency"
  isBold="true">
</app-simple-input>-->
